class PagesMainImgCustom {
    constructor(options) {
        this.documentBox = document.querySelector('.main-custom-page')
        this.documentBox1 = this.documentBox.querySelector('.main-custom-box')
        this.classBox = document.querySelector(options)
        this.init()
        this.initProduct()
    }

    // 提取图片到顶部
    init() {
        const imageBox = this.classBox.querySelector('img[data-title-img]')
        if (!imageBox) {
            console.log('no img[data-title-img]')
            return
        }
        const src = imageBox.getAttribute('src')
        const box = document.createElement('div')
        box.className = 'img-box'
        const imgItem = document.createElement('img')
        imgItem.src = src
        imgItem.className = 'img-box-item'
        box.append(imgItem)
        this.classBox.querySelector('img[data-title-img]').remove()

        this.documentBox.insertBefore(box, document.querySelector('.page.page-default'))
    }

    // 产品交互
    initProduct() {
        const product = document.querySelector('.custom-main-page-product')
        const productItemList = product.querySelectorAll('.item')

        if (!productItemList.length) {
            console.log('no item')
            return
        }

        productItemList.forEach(i => {
            const contentBox = i.querySelector('.item-list')
            i.querySelector('.item-title').addEventListener('click', () => {
                i.classList.toggle('active')
                contentBox.style.display = i.classList.contains('active') ? 'block' : 'none'
            })
        })

    }
}
